import { Pipe, PipeTransform } from '@angular/core';

import { UserService } from '@services';

import { isEmpty } from 'lodash';
import { TranslateService } from '@ngx-translate/core';

export interface DisplayItem {
  disabledAt: number;
}

@Pipe({
  name: 'displayItemTitle'
})
export class DisplayItemTitlePipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
    private userService: UserService
  ) {}

  transform(item: DisplayItem, titleProperty = 'name'): string {
    if (!item || isEmpty(item)) {
      return '';
    }

    const title = this.userService.translateItem(item, titleProperty);

    if (item?.disabledAt > 0) {
      return `${title} (${this.translate.instant('SHARED.Deactivated')})`;
    }

    return title;
  }
}
